
import React from 'react';

import Repos from './Repos';

export default () => (
  <div>
    <p>
      An app that graphs meet up events to RSVP count of a few meet up groups in the L.A. area.
      Data comes from <a href="https://meetup.com">meetup.com</a>.
    </p>

    <p>
      <Repos repos={[
        { href: 'https://github.com/michael-software-engr/phoenix_api', text: 'back end' },
        { href: 'https://github.com/michael-software-engr/timelines', text: 'front end' }
      ]} />
    </p>

    <p>Backend:
      {' '}<a href="http://elixir-lang.org/">Elixir</a>,
      {' '}<a href="http://www.phoenixframework.org/">Phoenix</a>
    </p>

    <p>Frontend:
      {' '}<a href="https://www.javascript.com/">JavaScript</a>
      {' '}<a href="https://facebook.github.io/react/">React</a>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/Timelines.js